const specialties = {
  specialtiesList: "Specialties",
  list: {
    relatedCatiegories: "Related categories",
    addedServices: "Added services",
    search: "Search for a specialty",
    noDataSubTitle: "There are no specialties to display yet",
    noDataDescription: "Start now to add specialties",
    createSpecialtiesButton: "Add a new specialty",
  },
  addSpecialty: {
    title: "Add new specialty",
    labels: {
      enTitle: "Title (En)",
      arTitle: "Title (Ar)",
      category: "Category",
    },
    placeholders: {
      enTitle: "Enter category english title",
      arTitle: "Enter category arabic title",
      category: "Choose from categories",
    },
  },
  editSpecialty: {
    title: "Edit specialty",
    labels: {
      edit: "Save",
    },
  },
  deleteSpecialty: {
    title: "Delete specialty",
    deleteConfirmationMsg: "Are you sure you want to delete this specialty? ",
  },
  viewSpecialty: {
    title: "Specialty details",
    noCategories: "No categories",
    noServices: "No services are added yet",
    addedByProvider: "Added by provider",
  },
};

export default specialties;
